export default __webpack_public_path__ + "static/media/git.305be34a.png";